var _style, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgrammingMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:transparent;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 50,
    height: 50
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 23.4,
    y: 34.6,
    className: "st0",
    width: 18.6,
    height: 3.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 17.9,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 18.5399 -5.4142)",
    className: "st0",
    width: 18.6,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 28.6,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 48.4264 40.596)",
    className: "st0",
    width: 18.6,
    height: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgrammingMode);
export default __webpack_public_path__ + "static/media/programming_mode.591448cfef8bcb4dbb1f792d75b22fd1.svg";
export { ForwardRef as ReactComponent };